module.exports = __webpack_public_path__ + "png/bg-pattern-white-repeatable.png";